export const BASE_URL = "https://vyralnet.com/";

export const API_END_POINTS = {
  /////////////////////////////<===MUTATIONS===>//////////////////////////////
  registerUser: BASE_URL + "open/user/create-user",
  registerWithInvitation: BASE_URL + "open/user/onboardinfluencer",
  loginUser: BASE_URL + "open/user/login",
  socialLogin: BASE_URL + "open/user/SocialLogin",
  forgotPassword: BASE_URL + "open/user/forgotpassword",
  resetPassword: BASE_URL + "open/user/resetpassword",
  changePassword: BASE_URL + "protected/user/change-password",
  signupBasic: BASE_URL + "protected/user/edit-profile",
  signupPost: BASE_URL + "protected/user/addinfluencerdetail",
  signupPackages: BASE_URL + "protected/user/createPackage",
  editPackages: BASE_URL + "protected/user/editPackage",
  addChallange: BASE_URL + "protected/user/challenge",
  messageMedia: BASE_URL + "open/user/messageStoragemulti",
  userProfilPic: BASE_URL + "protected/user/uploadProfilePic",
  addPitch: BASE_URL + "protected/user/makepitch",
  submitPitchContent: BASE_URL + "protected/user/submitcontent",
  directHire: BASE_URL + "protected/user/directhire",
  decideJobOffer: BASE_URL + "protected/user/decideJoboffer",
  submitFeedback: BASE_URL + "protected/user/ratesubmittedcontents",
  saveInfluencer: BASE_URL + "protected/user/likeinfluencer",
  addList: BASE_URL + "protected/user/addtoList",
  sendEmail: BASE_URL + "protected/user/sendEmailList",
  replyToEmail: BASE_URL + "protected/user/replyToEmail",
  seenNotification: BASE_URL + "protected/user/seenNotification",
  deleteList: BASE_URL + "protected/user/deletelist",
  editChallange: BASE_URL + "protected/user/UpdateChallenge",
  contactUs: BASE_URL + "protected/user/contactSupport",
  submitProfileForApproval: BASE_URL + "protected/user/submitProfile",
  removeInvite: BASE_URL + "protected/user/removeinvite",
  addBankAccount: BASE_URL + "protected/user/addbankaccount",
  makePayment: BASE_URL + "protected/user/makepayment",
  releasePayment: BASE_URL + "protected/user/releasepayment",
  saveCard: BASE_URL + "protected/user/addcard",
  deleteAccount: BASE_URL + "protected/user/deleteprofile",
  /////////////////////////////<===QUERIES===>////////////////////////////////
  getPackages: BASE_URL + "protected/user/myPackages",
  getInfluencers: BASE_URL + "protected/user/influencers",
  getInfluencersHome: BASE_URL + "protected/user/influencershompage",
  getInfluencerProfile: BASE_URL + "protected/user/Profile",
  getChallanges: BASE_URL + "protected/user/challenge",
  getChallangeDetail: BASE_URL + "protected/user/getChallengeDetail",
  getBrandChallanges: BASE_URL + "protected/user/getmyChallengesbrand",
  getCategories: BASE_URL + "open/user/categories",
  getChallangeProposals: BASE_URL + "protected/user/getChallengeproposalsbrand",
  getInfluencerChallanges: BASE_URL + "protected/user/getmychallengesinfluencer",
  getInfluencerJobs: BASE_URL + "protected/user/GetJobsInfluencer",
  getInfluencerDashboard: BASE_URL + "protected/user/influcencerDashboard",
  getJobOffers: BASE_URL + "protected/user/getJoboffers",
  getSubmittedContents: BASE_URL + "protected/user/getsubmittedcontents",
  savedInfluencers: BASE_URL + "protected/user/getLikedInfluencer",
  getList: BASE_URL + "protected/user/getListdata",
  getListProspects: BASE_URL + "protected/user/getListdataprospects",
  getListOutreached: BASE_URL + "protected/user/getListdataoutreached",
  getReports: BASE_URL + "protected/user/report",
  fetchLatestCounts: BASE_URL + "protected/user/fetchlatest",
  getEmail: BASE_URL + "protected/user/getInboxMessages",
  getNotifications: BASE_URL + "protected/user/getNotification",
  getHiredInfluencers: BASE_URL + "protected/user/myjobsbrand",
  getDashboard: BASE_URL + "protected/user/dashboard",
  getUserWithInvitation: BASE_URL + "open/user/checkinvitaionscode",
  influencerMainSearch: BASE_URL + "protected/user/influencersearch",
  influencerProfile: BASE_URL + "protected/user/influencerProfile",
  getChallengesDropdown: BASE_URL + "protected/user/currentchallengedropdown",
  getInvitedJobs: BASE_URL + "protected/user/getinvitedjobs",
  // getInfluencersFromRapid: "https://instagram-statistics-api.p.rapidapi.com/search",
  getInfluencersFromRapid: BASE_URL + "open/user/dummysearch",
  getHome: BASE_URL + "open/user/gethome",
  getCreator: BASE_URL + "open/user/getcreator",
  getPrivacy: BASE_URL + "open/user/getprivacy",
  getTerms: BASE_URL + "open/user/getterms",
  getAbout: BASE_URL + "open/user/getabout",
  getSettings: BASE_URL + "open/user/getsettings",
  getBrandTransactions: BASE_URL + "protected/user/getbrandtransactions",
  getInfluencerTransactions: BASE_URL + "protected/user/getinfluencertransactions",
  getInfluencerLeaderboard: BASE_URL + "protected/user/influencerleadorboard",
  getBrandTransactionChallange: BASE_URL + "protected/user/getbrandchallengestransaction",
  getBrandTransactionJobs: BASE_URL + "protected/user/getbrandjobs",
  getAllCards: BASE_URL + "protected/user/listcards",
  getInfDashboardChallange: BASE_URL + "protected/user/influcencerDashboardchallenge",
  getInfDashboardJob: BASE_URL + "protected/user/influcencerDashboardjob",
};